<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <div class="select">
            <select v-model="extra.mosaic">
              <option :value="null">全部</option>
              <option :value="true">有码</option>
              <option :value="false">无码</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <div class="control">
            <input class="input" type="text" placeholder="Actor Name" v-model="extra.name" />
          </div>
        </div>
      </div>
      <div class="column">
        <button class="button" @click="commit()">提交</button>
      </div>
    </div>
    <QueryPreview :query="extra" />
    <FlowBoard flowSource="/api/v1/jav/actor/" :query="$route.query" :card="card" :key="'actor'" />
  </div>
</template>

<script>
import FlowBoard from "./FlowBoard";
import Card from "./ActorCard";
import QueryPreview from "./QueryPreview";

export default {
  name: "ActorBoard",
  components: {
    FlowBoard,
    QueryPreview
  },
  props: {},
  data() {
    return {
      extra: {
        mosaic: null
      },
      card: Card
    };
  },
  activated: function() {
    this.extra = JSON.parse(JSON.stringify(this.$route.query));
  },
  methods: {
    commit: function() {
      this.$router.replace({ query: this.extra });
    }
  }
};
</script>

<style scoped>
</style>
